var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerTopBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 101,
    viewBox: "0 0 127 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.88 82.88C31.88 85.4667 31.44 87.84 30.56 90C29.7067 92.16 28.4533 93.9467 26.8 95.36L31.4 100.56H25L22.6 97.76C20.8933 98.3733 18.9867 98.68 16.88 98.68C13.6267 98.68 10.8667 98 8.6 96.64C6.36 95.2533 4.66667 93.3733 3.52 91C2.4 88.6 1.84 85.8933 1.84 82.88C1.84 79.92 2.4 77.2533 3.52 74.88C4.66667 72.5067 6.37333 70.6267 8.64 69.24C10.9067 67.8267 13.6533 67.12 16.88 67.12C20.08 67.12 22.8 67.8267 25.04 69.24C27.3067 70.6267 29.0133 72.52 30.16 74.92C31.3067 77.2933 31.88 79.9467 31.88 82.88ZM7.52 82.88C7.52 86.16 8.32 88.8267 9.92 90.88C11.5467 92.9067 13.8667 93.92 16.88 93.92C17.68 93.92 18.4133 93.84 19.08 93.68L14.64 88.52H20.88L23.32 91.28C24.2533 90.2933 24.96 89.0667 25.44 87.6C25.9467 86.1333 26.2 84.52 26.2 82.76C26.2 80.7067 25.8267 78.8667 25.08 77.24C24.3333 75.5867 23.2533 74.28 21.84 73.32C20.4533 72.36 18.8 71.88 16.88 71.88C14.88 71.88 13.1733 72.36 11.76 73.32C10.3467 74.28 9.28 75.6 8.56 77.28C7.86667 78.9333 7.52 80.8 7.52 82.88ZM115.197 98.3835C113.28 98.3835 111.618 97.9616 110.212 97.1179C108.805 96.2741 107.714 95.0937 106.939 93.5767C106.172 92.0597 105.788 90.2869 105.788 88.2585C105.788 86.2301 106.172 84.4531 106.939 82.9276C107.714 81.402 108.805 80.2173 110.212 79.3736C111.618 78.5298 113.28 78.108 115.197 78.108C117.115 78.108 118.777 78.5298 120.183 79.3736C121.589 80.2173 122.676 81.402 123.443 82.9276C124.219 84.4531 124.606 86.2301 124.606 88.2585C124.606 90.2869 124.219 92.0597 123.443 93.5767C122.676 95.0937 121.589 96.2741 120.183 97.1179C118.777 97.9616 117.115 98.3835 115.197 98.3835ZM115.223 94.6761C116.263 94.6761 117.132 94.3906 117.831 93.8196C118.53 93.2401 119.05 92.4645 119.391 91.4929C119.74 90.5213 119.915 89.4389 119.915 88.2457C119.915 87.044 119.74 85.9574 119.391 84.9858C119.05 84.0057 118.53 83.2259 117.831 82.6463C117.132 82.0668 116.263 81.777 115.223 81.777C114.158 81.777 113.271 82.0668 112.564 82.6463C111.865 83.2259 111.341 84.0057 110.991 84.9858C110.651 85.9574 110.48 87.044 110.48 88.2457C110.48 89.4389 110.651 90.5213 110.991 91.4929C111.341 92.4645 111.865 93.2401 112.564 93.8196C113.271 94.3906 114.158 94.6761 115.223 94.6761Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3653 89.7415V78.3636H53.9932V98H49.506V94.5099H49.3014C48.8582 95.6094 48.1295 96.5085 47.1153 97.2074C46.1097 97.9062 44.8696 98.2557 43.3952 98.2557C42.1082 98.2557 40.9705 97.9702 39.9818 97.3991C39.0017 96.8196 38.2347 95.9801 37.6807 94.8807C37.1267 93.7727 36.8497 92.4347 36.8497 90.8665V78.3636H41.4776V90.1506C41.4776 91.3949 41.8185 92.3835 42.5003 93.1165C43.1821 93.8494 44.077 94.2159 45.1849 94.2159C45.8668 94.2159 46.5273 94.0497 47.1665 93.7173C47.8057 93.3849 48.3298 92.8906 48.7389 92.2344C49.1565 91.5696 49.3653 90.7386 49.3653 89.7415Z",
    fill: "#522785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1652 98.3835C66.1965 98.3835 64.4962 97.9744 63.0644 97.1562C61.6411 96.3295 60.5459 95.1619 59.7789 93.6534C59.0118 92.1364 58.6283 90.3509 58.6283 88.2969C58.6283 86.277 59.0118 84.5043 59.7789 82.9787C60.5544 81.4446 61.6368 80.2514 63.026 79.3991C64.4152 78.5384 66.0473 78.108 67.9223 78.108C69.1326 78.108 70.2746 78.304 71.3485 78.696C72.4309 79.0795 73.3854 79.6761 74.2121 80.4858C75.0473 81.2955 75.7036 82.3267 76.1809 83.5795C76.6581 84.8239 76.8968 86.3068 76.8968 88.0284V89.4474H60.8016V86.3281H72.4607C72.4522 85.4418 72.2604 84.6534 71.8854 83.9631C71.5104 83.2642 70.9863 82.7145 70.313 82.3139C69.6482 81.9134 68.8726 81.7131 67.9863 81.7131C67.0402 81.7131 66.2093 81.9432 65.4934 82.4034C64.7775 82.8551 64.2192 83.4517 63.8187 84.1932C63.4266 84.9261 63.2263 85.7315 63.2178 86.6094V89.3324C63.2178 90.4744 63.4266 91.4545 63.8442 92.2727C64.2618 93.0824 64.8456 93.7045 65.5956 94.1392C66.3456 94.5653 67.2235 94.7784 68.2292 94.7784C68.9025 94.7784 69.5118 94.6847 70.0573 94.4972C70.6027 94.3011 71.0758 94.0156 71.4763 93.6406C71.8769 93.2656 72.1794 92.8011 72.384 92.2472L76.705 92.733C76.4323 93.875 75.9124 94.8722 75.1454 95.7244C74.3868 96.5682 73.4152 97.2244 72.2306 97.6932C71.0459 98.1534 69.6908 98.3835 68.1652 98.3835Z",
    fill: "#ED1E79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5319 98V78.3636H86.0191V81.6364H86.2237C86.5816 80.5028 87.1953 79.6293 88.0646 79.0156C88.9424 78.3935 89.9438 78.0824 91.0688 78.0824C91.3245 78.0824 91.61 78.0952 91.9254 78.1207C92.2492 78.1378 92.5177 78.1676 92.7308 78.2102V82.4673C92.5347 82.3991 92.2237 82.3395 91.7975 82.2884C91.3799 82.2287 90.9751 82.1989 90.583 82.1989C89.7393 82.1989 88.9808 82.3821 88.3075 82.7486C87.6427 83.1065 87.1185 83.6051 86.735 84.2443C86.3515 84.8835 86.1597 85.6207 86.1597 86.456V98H81.5319Z",
    fill: "#F15A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5253 98V78.3636H101.153V98H96.5253ZM98.852 75.5767C98.1191 75.5767 97.4884 75.3338 96.96 74.848C96.4316 74.3537 96.1674 73.7614 96.1674 73.071C96.1674 72.3722 96.4316 71.7798 96.96 71.294C97.4884 70.7997 98.1191 70.5526 98.852 70.5526C99.5935 70.5526 100.224 70.7997 100.744 71.294C101.272 71.7798 101.537 72.3722 101.537 73.071C101.537 73.7614 101.272 74.3537 100.744 74.848C100.224 75.3338 99.5935 75.5767 98.852 75.5767Z",
    fill: "#FBB03B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9128 54.3694V15.0047H79.8369V42.2572L93.9128 54.3694Z",
    fill: "#522785",
    stroke: "#522785"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0752 14.2477V1H80.9768L93.5309 14.2477H44.0752Z",
    fill: "#29ABE2",
    stroke: "#29ABE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.315 50.5844H30L30 13.8693L43.315 1.37856L43.315 50.5844Z",
    fill: "#F15A24",
    stroke: "#F15A24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5536 63.4536L30.3799 50.9628H72.9879L85.1616 63.4536H42.5536Z",
    fill: "#FBB03B",
    stroke: "#FBB03B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.7178,
    y: 32.416,
    width: 3.80429,
    height: 3.78507,
    fill: "#FBB03B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.958,
    y: 43.7712,
    width: 3.04343,
    height: 3.02876,
    fill: "#FBB03B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7402,
    y: 55.1265,
    width: 3.04343,
    height: 3.02876,
    fill: "#522785"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89.3438,
    y: 41.5002,
    width: 2.28257,
    height: 2.27157,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 55.1265,
    width: 2.28257,
    height: 2.27157,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4131,
    y: 44.1497,
    width: 3.80429,
    height: 3.78507,
    fill: "#FBB03B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2588,
    y: 36.9581,
    width: 3.80429,
    height: 3.78507,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1299,
    y: 57.3976,
    width: 3.80429,
    height: 3.78507,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96.1963,
    y: 53.6124,
    width: 3.80429,
    height: 3.78507,
    fill: "#522785"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7822,
    y: 65.7246,
    width: 3.80429,
    height: 3.78507,
    fill: "#522785"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1299,
    y: 30.902,
    width: 4.56514,
    height: 4.54208,
    fill: "#FBB03B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95.4336,
    y: 64.9677,
    width: 4.56514,
    height: 4.54208,
    fill: "#522785"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8018,
    y: 38.4722,
    width: 5.326,
    height: 5.29909,
    fill: "#FBB03B"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 87.8252,
    y: 57.3976,
    width: 5.326,
    height: 5.29909,
    fill: "#522785"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0869,
    y: 49.8274,
    width: 5.326,
    height: 5.29909,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8438,
    y: 49.0703,
    width: 5.326,
    height: 5.29909,
    fill: "#FBB03B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 85.542,
    y: 48.3133,
    width: 5.326,
    height: 5.29909,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7822,
    y: 49.0703,
    width: 5.326,
    height: 5.29909,
    fill: "#522785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerTopBlack);
export default __webpack_public_path__ + "static/media/DrawerTopBlack.dab4924990a789e4788a3e6cee86ab25.svg";
export { ForwardRef as ReactComponent };